import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { LanguageProvider } from '../context/LanguageContext.jsx';
import { StoreProvider } from '../context/StoreContext.jsx';
import { router } from './router.jsx';

export function App() {
  return (
    <LanguageProvider>
      <StoreProvider>
        <RouterProvider router={router} />
      </StoreProvider>
    </LanguageProvider>
  );
}

export default App;
